/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-label-repeater',
  template: `
    @for (label of labelArray; track $index) {
      @if (isReadOnly) {
        <span class="resourceLabel label label-primary">{{label}}</span>
      } @else {
        <a class="resourceLabel label label-primary" (click)="search(label)">{{label}}</a>
      }
    }
  `
})
export class LabelRepeaterComponent {
  @Input() labels: string[] = [];
  @Input() readOnly: any;

  constructor(private readonly stateService: StateService) {}

  get labelArray(): string[] {
    return this.labels || [];
  }

  get isReadOnly(): boolean {
    return this.readOnly === true || this.readOnly === 'true';
  }

  search(label: string): void {
    this.stateService.go('app.search', {labels: label});
  }
}
